module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAARFJREFUOE+tkz0vRFEQhp93s/EL6BQ6oeJs7ViNaEloKNT+wOroJHq1hoaCVqJYZyWiOTo6FYmEfyDuyF33yu51l9ysKWfOPPOe+RBDmobMpw9gvrGIkkmovaD6jdq3T2kBa85M8FFrUmME2aPad5d54W+AeXcErPcpSpIFVH9HyXVB6YVCXEp9XYDNN7YwOyj5zjOYgcZLYhsK8TgDuEOMzYr9OFWIa18A706A1UoAca6ruJwBZvdA25UAxr46sdXbRKsCUIjd3MIY3Ssw+gfoTSGO/Rhj7jDv7oGpAZAHhTjdGyvdRPMuAHMFSEch+iJ44Cqbd7vATpZwphBXylT9egsZBIWYwkrtf4+pyhjzt58jP08R+FYArAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_goods_attention_full.png
// module id = gr+l
// module chunks = 192